import { z } from 'zod'

// ----- Item Approval --------------------------------------------

export const ItemApprovalSchema = z.object({
  id: z.number(),
  deal_id: z.number(),
  item_id: z.number(),
  version_id: z.number().nullable(),
  created_by_id: z.number(),
  approval_group_ids: z.array(z.number()),
  approver_ids: z.array(z.number()),
  state: z.enum(['pending', 'approved', 'rejected']),
  date_created: z.string(),
  state_updated_at: z.string().nullable(),
  state_updated_by: z.string().nullable(),
  approval_ratio: z.string(),
  approval_message: z.string(),
  approval_message_edited_at: z.string().nullable(),
  approval_message_edited_by: z.string().nullable(),
})

export const RedactedItemApprovalSchema = z.object({
  id: z.number(),
  deal_id: z.number(),
  item_id: z.number(),
  approver_ids: z.array(z.number()),
  created_by_id: z.number(),
  gas_is_redacted: z.boolean(),
})

// ----- Approval Group -------------------------------------------

export const ApprovalGroupSchema = z.object({
  id: z.number(),
  firm_id: z.number(),
  item_approval_id: z.number(),
  approver_ids: z.array(z.number()),
  approval_type: z.enum(['all', 'any']),
  state: z.enum(['pending', 'approved', 'rejected']),
  state_updated_at: z.string().nullable(),
  has_access: z.boolean(),
})

// ----- Approver -------------------------------------------------

export const ApproverSchema = z.object({
  id: z.number(),
  item_id: z.number(),
  user_id: z.number(),
  item_approval_id: z.number(),
  approval_group_id: z.number(),
  request_sent_by_id: z.number().nullable(),
  state: z.enum(['created', 'sent', 'approved', 'rejected']),
  state_updated_at: z.string().nullable(),
  rejection_comment: z.string(),
  obsolete: z.boolean(),
  has_access: z.boolean(),
})

export const RedactedApproverSchema = z.object({
  id: z.number(),
  deal_id: z.number(),
  item_id: z.number(),
  item_approval_id: z.number(),
  request_sent_by_id: z.number().nullable(),
  gas_is_redacted: z.boolean(),
})

// ----- Mutation Requests ----------------------------------------

const ApprovalGroupRequestSchema = z.object({
  firm_id: z.number(),
  user_ids: z.array(z.number()),
  approval_type: z.enum(['all', 'any']),
})

export const BulkCreateItemApprovalsRequestSchema = z.object({
  item_ids: z.array(z.number()),
  approval_groups: z.array(ApprovalGroupRequestSchema),
  send_email: z.boolean(),
  request_comment: z.string(),
})

export const ManageApproversRequestSchema = z.object({
  approval_groups: z.array(ApprovalGroupRequestSchema),
})

export const SendApprovalRequestsRequestSchema = z.object({
  approver_ids: z.array(z.number()),
  request_comment: z.string(),
  update_approval_message: z.boolean(),
})

export const EditApprovalMessageRequestSchema = z.object({
  approval_message: z.string(),
})

export const RejectApproverRequestSchema = z.object({
  rejection_comment: z.string(),
})

// ----- Pusher ---------------------------------------------------

export const ApprovalsBatchPayloadSchema = z.object({
  job_id: z.string(),
  delete: z.array(z.unknown()),
  create: z.union([
    z.array(z.unknown()),
    z.object({
      'item-approval': z.array(z.number()).optional(),
      'approval-group': z.array(z.number()).optional(),
      approver: z.array(z.number()).optional(),
    }),
  ]),
  reject: z.union([
    z.array(z.unknown()),
    z.object({
      item: z.array(z.number()).optional(),
    }),
  ]),
  update: z.array(z.unknown()),
  expected_jobs: z.number(),
})
